const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function setVisible(items) {
  items.forEach((item) => item.classList.add('is-visible'));
}

function setupCinemaMoments() {
  const items = [...document.querySelectorAll('[data-axiom-cinema]')];
  if (!items.length) return;

  if (reduceMotionQuery.matches || !('IntersectionObserver' in window)) {
    setVisible(items);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  items.forEach((item) => observer.observe(item));
}

function normalizeTokens(value) {
  return (value || '')
    .toLowerCase()
    .split(',')
    .map((token) => token.trim())
    .filter(Boolean);
}

function cardMatches(card, token) {
  if (token === 'all') return true;

  const domains = normalizeTokens(card.dataset.domains);
  const tags = normalizeTokens(card.dataset.tags);
  return domains.includes(token) || tags.includes(`domain:${token}`) || tags.includes(token);
}

function updateGrid(grid, token, note) {
  const cards = [...grid.querySelectorAll('[data-axiom-product-card]')];
  let matches = 0;

  cards.forEach((card) => {
    const match = cardMatches(card, token);
    card.hidden = !match;
    if (match) matches += 1;
  });

  if (token !== 'all' && matches === 0) {
    cards.forEach((card) => {
      card.hidden = false;
    });
    if (note) {
      note.hidden = false;
    }
    return;
  }

  if (note) {
    note.hidden = true;
  }
}

function setupDomainFilters() {
  const browsers = [...document.querySelectorAll('[data-axiom-domain-browser]')];
  if (!browsers.length) return;

  browsers.forEach((browser) => {
    const target = browser.dataset.targetGrid;
    const grid = document.querySelector(`[data-axiom-product-grid="${target}"]`);
    if (!grid) return;

    const note = browser.querySelector('[data-axiom-domain-note]');
    const buttons = [...browser.querySelectorAll('[data-axiom-domain-key]')];

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const token = button.dataset.domainKey || 'all';

        buttons.forEach((candidate) => {
          candidate.setAttribute('aria-pressed', String(candidate === button));
        });

        updateGrid(grid, token, note);
      });
    });
  });
}

function initAxiomTheme() {
  setupCinemaMoments();
  setupDomainFilters();
}

document.addEventListener('DOMContentLoaded', initAxiomTheme);
document.addEventListener('shopify:section:load', initAxiomTheme);
